import * as qs from 'qs';
import {API} from '../API';
import {NoteService} from './NoteService';

export class TaskService {

  constructor() {
    this.note = new NoteService();
  }

  async getTableTasks(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getTasks(query, page, length);
  }

  async getTasks(query, page, length) {
    return (await API.getConnection())
      .get('tasks', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async getTask(id, archive = false) {
    return (await API.getConnection())
      .get(`tasks/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async createTask(task) {
    return (await API.getConnection())
      .post('tasks', task)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async updateTask(task, updates) {
    return (await API.getConnection())
      .put(`tasks/${task.id}`, updates)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async completeTask(task, deadline = null) {
    return (await API.getConnection())
      .patch(`tasks/${task.id}`, {deadline})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async revertTask(task, removeFutureOccurrences = false) {
    return (await API.getConnection())
      .patch(`tasks/${task.id}/revert`, {remove_future_occurrences: removeFutureOccurrences})
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async deleteTask(task) {
    return (await API.getConnection())
      .delete(`tasks/${task.id}`)
      .then(() => null)
      .catch(error => API.handleError(error));
  }

  async restoreTask(task) {
    return (await API.getConnection())
      .put(`tasks/${task.id}/restore`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
